// Main JavaScript for Untamed theme

document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu toggle
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const navMenu = document.querySelector('.nav__list');
  
  if (mobileMenuToggle && navMenu) {
    mobileMenuToggle.addEventListener('click', function() {
      navMenu.classList.toggle('active');
      mobileMenuToggle.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });
  }

  // Product image gallery
  const productThumbnails = document.querySelectorAll('.product-thumbnail');
  const productMainImage = document.querySelector('.product-main-image');

  if (productThumbnails.length && productMainImage) {
    productThumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const newSrc = this.getAttribute('data-image');
        const newAlt = this.getAttribute('data-alt');
        
        productMainImage.setAttribute('src', newSrc);
        productMainImage.setAttribute('alt', newAlt);
        
        // Remove active class from all thumbnails
        productThumbnails.forEach(thumb => thumb.classList.remove('active'));
        
        // Add active class to clicked thumbnail
        this.classList.add('active');
      });
    });
  }

  // Sticky header
  const header = document.querySelector('.header');
  let lastScrollPosition = 0;

  if (header) {
    window.addEventListener('scroll', function() {
      const currentScrollPosition = window.pageYOffset;
      
      if (currentScrollPosition > 100) {
        header.classList.add('header--sticky');
        
        if (currentScrollPosition > lastScrollPosition) {
          header.classList.add('header--hidden');
        } else {
          header.classList.remove('header--hidden');
        }
      } else {
        header.classList.remove('header--sticky', 'header--hidden');
      }
      
      lastScrollPosition = currentScrollPosition;
    });
  }

  // Countdown Timer Logic
  function updateCountdowns() {
    if (!window.__untamedCountdowns) return;
    window.__untamedCountdowns.forEach(function(timer) {
      var el = document.getElementById(timer.id);
      if (!el) return;
      var end = new Date(timer.endDate).getTime();
      var now = new Date().getTime();
      var diff = end - now;
      if (diff < 0) diff = 0;
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);
      el.querySelector('.countdown-days').textContent = String(days).padStart(2, '0');
      el.querySelector('.countdown-hours').textContent = String(hours).padStart(2, '0');
      el.querySelector('.countdown-minutes').textContent = String(minutes).padStart(2, '0');
      el.querySelector('.countdown-seconds').textContent = String(seconds).padStart(2, '0');
    });
  }
  setInterval(updateCountdowns, 1000);
  document.addEventListener('DOMContentLoaded', updateCountdowns);

  // Text Reveal
  const revealElements = document.querySelectorAll('.text-reveal');
  revealElements.forEach(splitTextToSpans);
  const observer = new window.IntersectionObserver(revealTextInViewport, {
    threshold: 0.2
  });
  revealElements.forEach(el => observer.observe(el));
});

// Text Reveal Animation
function splitTextToSpans(element) {
  if (!element) return;
  if (element.dataset.splitted === 'true') return;
  const text = element.textContent;
  element.textContent = '';
  text.split('').forEach((char, i) => {
    const span = document.createElement('span');
    span.textContent = char === ' ' ? '\u00A0' : char;
    span.style.animationDelay = (i * 0.04) + 's';
    element.appendChild(span);
  });
  element.dataset.splitted = 'true';
}

function revealTextInViewport(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('text-reveal--active');
      observer.unobserve(entry.target);
    }
  });
} 